import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3009/api/v1';

export type UsabilityReport = {
  range: { from: string; to: string };
  notes: { streaming: string; recordings: string; perifoneo: string };
  totals: {
    users: number;
    recordings: number;
    streaming: number | null;
    downloads: number;
    perifoneo: number;
  };
  clients: Array<{
    userId: number;
    email: string;
    username: string | null;
    nationalId: string | null;
    activity: {
      streaming: number | null;
      recordings: number;
      downloads: number;
      perifoneo: number;
    };
  }>;
};

export async function fetchUsabilityReport(token: string): Promise<UsabilityReport> {
  const res = await axios.get<UsabilityReport>(`${API_URL}/usability/clients`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}
